import { useState } from "react";
import { TextField, Snackbar, Alert } from "@mui/material";
import styles from "./changepassword.module.css";
import { useForm, Controller } from "react-hook-form";
import { authData, withCustomerAuth } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import { StorageRemoveItem, STORAGE_KEYS } from "../../../admin/components/StorageComp";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../../components/sideBar";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";

function ChangePassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const { websiteData } = useWebsite();
  useSiteBranding("Change your password", websiteData);

  const { register, handleSubmit, watch, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  const onSubmit = (data) => {
    setLoading(true);

    const postData = {
      current_password: data?.current_password,
      password: data?.password,
      password_confirmation: data?.conf_password,
    };

    return axios.post(process.env.REACT_APP_API_URL + "v1/customer/change-password", postData, {
      headers: {
        Authorization: `Bearer ${authData()?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMessage(response.data.message);
      if (response.data.status === "SUCCESS") {
        setSnackbarType("success");
        StorageRemoveItem(STORAGE_KEYS.AUTH);
        setTimeout(() => {
          navigate("/sign-in");
        }, 2000);
      } else {
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMessage(error?.response?.data?.message || "Something went wrong. Please try again.");
      setSnackbarType("error");
    });
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>

              <div className={`${styles.UserHead}`}>
                <p className={styles.PageHeadEyebrow}>Account</p>
                <p className={`${styles.UserProName}`}>Change password</p>
                <p className={styles.UserHeadSub}>You'll be signed out on other devices after this change.</p>
              </div>

              <div className={`${styles.UserProDe}`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className={styles.FormCard}>
                    <div className={`${styles.FormRow}`}>
                      <div className={styles.FormGroup}>
                        <Controller
                          {...register("current_password", { required: "This field is Required" })}
                          control={control}
                          render={({ field }) => (<TextField {...field} label="Current Password*" variant="outlined" type="password" autoComplete="current-password" />)}
                        />
                        {errors.current_password && (<span className={styles.ErrorM}>{errors?.current_password?.message}</span>)}
                      </div>
                    </div>
                    <div className={`${styles.FormRow}`}>
                      <div className={styles.FormGroup}>
                        <Controller
                          {...register("password", {
                            required: "This field is Required",
                            minLength: { value: 8, message: "Use at least 8 characters" },
                          })}
                          control={control}
                          render={({ field }) => (<TextField {...field} label="New Password*" variant="outlined" type="password" autoComplete="new-password" />)}
                        />
                        {errors.password && (<span className={styles.ErrorM}>{errors?.password?.message}</span>)}
                      </div>
                      <div className={styles.FormGroup}>
                        <Controller
                          {...register("conf_password", {
                            required: "This field is Required",
                            validate: (val) => {
                              if (watch("password") !== val) {
                                return "Your passwords do no match";
                              }
                            }
                          })}
                          control={control}
                          render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm New Password*" variant="outlined" type="password" autoComplete="new-password" />)}
                        />
                        {errors.conf_password && (<span className={styles.ErrorM}>{errors?.conf_password?.message}</span>)}
                      </div>
                    </div>

                    <div className={styles.MyProBUSec}>
                      <button type="submit" className={`${styles.LoginBU}`}>
                        <span>Change Password</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default withCustomerAuth(ChangePassword);